import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Grid, Row, Col, Alert } from 'react-bootstrap';
import { injectIntl, FormattedMessage } from 'react-intl';

import { parseQs } from 'helpers/http';

import TodaysTasks from 'components/layout/dashboard/TodaysTasks';
import OverdueTasks from 'components/layout/dashboard/OverdueTasks';
import OrderTotals from 'components/layout/dashboard/OrderTotals';
import OrderItems from 'components/layout/dashboard/OrderItems';

import Hints from 'components/layout/hint/DashboardIndex';

import Breadcrumb from 'components/layout/Breadcrumb';
import Loader from 'components/layout/Loader';

import Data from 'components/Data';
import LoginStats from 'components/layout/dashboard/LoginStats';
import EditionStats from 'components/layout/dashboard/EditionStats';
import CouponStats from 'components/layout/dashboard/CouponStats';
import TurnoverStats from 'components/layout/dashboard/TurnoverStats';
import may from 'js/security';
import { ROLE_ROOT_EMPLOYEE, ROLE_WL_ADMIN } from 'js/constants';


class DashboardEmployee extends React.Component {
  getNewClientsHint = () => {
    const { data } = this.props;

    const clientsCurrentPeriod = data.data.new_clients_count ? data.data.new_clients_count : 0;
    const clientsPreviousPeriod = data.data.previous_period_new_clients_count
      ? data.data.previous_period_new_clients_count
      : 0;

    const formatMessage = (percent, label) => (
      <span>
        <span class="label font-secondary m-r-5">{percent}%</span>
        {label}
      </span>
    );

    if (clientsCurrentPeriod >= clientsPreviousPeriod) {
      const increase = clientsCurrentPeriod - clientsPreviousPeriod;

      if (clientsPreviousPeriod > 0) {
        return formatMessage(increase % clientsPreviousPeriod, 'Higher');
      }

      if (clientsCurrentPeriod > 0) {
        return formatMessage(100, 'Change');
      }

      return formatMessage(0, 'Change');
    }

    const decrease = clientsCurrentPeriod - clientsPreviousPeriod;
    return formatMessage(decrease % clientsPreviousPeriod, 'Lower');
  };

  getMoneyWonSum = () => {
    const { data, webApp } = this.props;
    const values = data?.data?.money_won_sum;
    if (values) {
      const { amount } = Object.values(values).find(({ currency }) => currency === webApp.currency) ?? {};
      if (amount) {
        return amount;
      }
    }

    return 0;
  };

  getLeadsWonCount = () => {
    const leadsWonCount = this.props.data.data.leads_won_count;
    return leadsWonCount !== undefined ? Number(leadsWonCount) : 0;
  };

  getLeadsLostCount = () => {
    const leadsLostCount = this.props.data.data.leads_lost_count;
    return leadsLostCount !== undefined ? Number(leadsLostCount) : 0;
  };

  render() {
    const {
      intl: { messages },
      webApp,
      user,
      appIntl,
      location,
      data,
      projectConfig,
    } = this.props;

    const { pending } = data;
    const query = parseQs(location.search);

    return (
      <div class="padding-25 sm-padding-10">
        <Data dataName="dashboard" url="/api/dashboard.json" data={data} />

        <Breadcrumb crumbs={[{ link: appIntl.urlPrefix + 'account', name: 'Dashboard' }]} />

        <h1>
          <FormattedMessage
            id="welcome_message"
            values={{
              name: user.profile.first_name + ' ' + user.profile.last_name,
            }}
          />
        </h1>

        {/* stripe connect success message: */}
        {query.stripe_success && query.stripe_success === 'true' && (
          <Alert bsStyle="success">
            <h4>{messages.stripe_account_connected}</h4>
            <p class="no-margin">
              <FormattedMessage
                id="stripe_accounts_are_connected"
                values={{
                  projectName: projectConfig.data.name,
                }}
              />
            </p>
          </Alert>
        )}

        <Hints />

        {pending ? (
          <Loader />
        ) : (
          <>
            {(user.username === 'CreacheckAdmin' || may(ROLE_WL_ADMIN, user.roles)) && (<LoginStats />)}
            <OrderTotals data={data} />
            <OrderItems data={data} />

            {(user.username === 'CreacheckAdmin' || may(ROLE_ROOT_EMPLOYEE, user.roles)) && (<TurnoverStats />)}
            {(user.username === 'CreacheckAdmin' || may(ROLE_ROOT_EMPLOYEE, user.roles)) && (<CouponStats />)}
            <EditionStats />

            <Grid fluid class="no-padding">
              <Row>
                <Col xs={12} md={6}>
                  <TodaysTasks />
                </Col>
                <Col xs={12} md={6}>
                  <OverdueTasks />
                </Col>
              </Row>
            </Grid>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    webApp: state.webApp,
    appIntl: state.intl,
    user: state.login.user,
    data: state.data.dashboard,
    projectConfig: state.data.projectConfig,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(DashboardEmployee)));
